import React, {useEffect} from 'react';
import {
  Modal,
  SliderImg,
  SliderWrapper,
  ExitButton,
  DownloadLink,
  DownloadButton,
  Arrow,
  CenterSlide,
  SliderSign,
} from './styles';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ExitIcon from '../../../images/close.svg';
import DownloadIcon from '../../../images/download.svg';
import ArrowLeft from '../../../images/arrow_left.svg';
import ArrowRight from '../../../images/arrow_right.svg';
import ReactHtmlParser from 'react-html-parser';
import {useLocation} from '@reach/router';

const GallerySlider = ({images, selectedIndex, setSelectedIndex}) => {
  const location = useLocation();

  useEffect(() => {
    document.querySelector('html').style.overflow = 'hidden';
    document.querySelector('footer').style.zIndex = '-1';
    if (location.pathname.includes('about')) {
      document.querySelectorAll('.parallax-inner')[1].style.transform = 'none';
    }
    return () => {
      document.querySelector('html').style.overflow = 'unset';
      document.querySelector('footer').style.zIndex = '0';
      if (location.pathname.includes('about')) {
        document.querySelectorAll('.parallax-inner')[1].style.transform =
          'initial';
      }
    };
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: selectedIndex,
    nextArrow: <Arrow src={ArrowRight} />,
    prevArrow: <Arrow src={ArrowLeft} />,
    afterChange: (i) => setSelectedIndex(i),
  };

  return (
    <Modal>
      <SliderWrapper>
        <ExitButton src={ExitIcon} onClick={() => setSelectedIndex(null)} />

        <Slider {...settings}>
          {images.map(({src, sign}) => (
            <div>
              <CenterSlide>
                <SliderImg key={src} src={src} />
                <SliderSign>{ReactHtmlParser(sign)}</SliderSign>
              </CenterSlide>
            </div>
          ))}
        </Slider>
        <DownloadLink
          href={images[selectedIndex].src}
          download={images[selectedIndex]}>
          <DownloadButton src={DownloadIcon} />
        </DownloadLink>
      </SliderWrapper>
    </Modal>
  );
};

export default GallerySlider;
